<template>
  <router-view/>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>

  html, body {
    /*font-family: 'Open Sans', serif;*/
    font-size: 100%;
    line-height: 1.5;
    height: 100%;
    /*background: #4b5a71;*/
  }

  .container {
    max-width: 380px !important;
  }

  footer {
    max-width: 500px;
    margin: auto;
  }

  .button {
    max-width: 500px !important;
  }

  select {
    width: 100%;
  }

  .select {
    width: 100%;
  }

  .help.counter {
    display: none;
  }


  .columns {
    width: 100%;
    margin-left: 0;
    background: #ECF0F3;
    -webkit-box-shadow: 0 1px 1px 0 rgba(0, 28, 36, .5);
    box-shadow: 0 1px 1px 0 rgba(0, 28, 36, .5);
  }

  .fas.fa-bars {
    cursor: pointer;
  }

  .hero-body {
    background-image: linear-gradient(to left top, #ffc6c6, #d6a7b8, #a78ca6, #77738f, #4b5a71);
  }

</style>



// WEBPACK FOOTER //
// src/App.vue